const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const mediaUrl = (id) => `${API}/jobs/${id}/media`;

export async function fetchJobs() {
  const res = await fetch(`${API}/jobs`);
  if (!res.ok) throw new Error("Failed to load");
  return res.json();
}

export async function adminLogin(password) {
  const res = await fetch(`${API}/admin/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ password }),
  });
  return res.ok;
}

export async function uploadJob(password, title, file) {
  const fd = new FormData();
  fd.append("title", title);
  fd.append("file", file);
  const res = await fetch(`${API}/admin/jobs`, {
    method: "POST",
    headers: { "X-Admin-Password": password },
    body: fd,
  });
  if (!res.ok) {
    const d = await res.json().catch(() => ({}));
    throw new Error(d.detail || "Upload failed");
  }
  return res.json();
}

export async function deleteJob(password, id) {
  const res = await fetch(`${API}/admin/jobs/${id}`, {
    method: "DELETE",
    headers: { "X-Admin-Password": password },
  });
  if (!res.ok) throw new Error("Delete failed");
  return res.json();
}

export async function renameJob(password, id, title) {
  const res = await fetch(`${API}/admin/jobs/${id}`, {
    method: "PATCH",
    headers: { "X-Admin-Password": password, "Content-Type": "application/json" },
    body: JSON.stringify({ title }),
  });
  if (!res.ok) throw new Error("Rename failed");
  return res.json();
}
